/** Section heading — match prototype `.section-h` styling.
 *  Uppercase letter-spacing 0.04em, optional right-side meta + link. */

import type { ReactNode } from "react";
import { Link } from "react-router";
import { Ic } from "./icons";

export interface SectionHeadingProps {
  title: string;
  meta?: ReactNode;
  linkLabel?: string;
  linkTo?: string;
  onLinkClick?: () => void;
  style?: React.CSSProperties;
}

export function SectionHeading({
  title,
  meta,
  linkLabel,
  linkTo,
  onLinkClick,
  style,
}: SectionHeadingProps) {
  return (
    <div className="section-h" style={style}>
      <h2>{title}</h2>
      {meta && <span className="meta">{meta}</span>}
      {linkLabel &&
        (linkTo ? (
          <Link className="link" to={linkTo}>
            {linkLabel} <Ic.ArrowRight size={12} />
          </Link>
        ) : (
          <button type="button" className="link" onClick={onLinkClick}>
            {linkLabel} <Ic.ArrowRight size={12} />
          </button>
        ))}
    </div>
  );
}
